<script lang="ts">
  import {createEventDispatcher} from 'svelte';

  const dispatch = createEventDispatcher();

  export let selectedDate: Date | null;
  export let minDate: Date | null;
  export let maxDate: Date | null;

  $: selectedYear = selectedDate && selectedDate.getFullYear();
  $: minYear = minDate
    ? new Date(minDate).getFullYear()
    : new Date().getFullYear() - 100;
  $: maxYear = maxDate
    ? new Date(maxDate).getFullYear()
    : new Date().getFullYear() + 50;

  let yearRefs: Record<number, HTMLButtonElement> = {};

  // Scroll selected or today's year into view
  $: {
    const focusYear = selectedYear || new Date().getFullYear();
    const element = yearRefs[focusYear];

    if (
      element &&
      element.parentNode &&
      element.parentNode instanceof HTMLElement
    ) {
      element.parentNode.scrollTop =
        element.offsetTop - element.parentNode.offsetTop;
    }
  }

  // Returns whether the given year is today or not
  const isToday = (year: number) => {
    const today = new Date();
    const thisYear = today.getFullYear();

    return thisYear === year;
  };

  // Returns whether the given year is selected or not
  $: isSelected = (year: number) => {
    return selectedDate && selectedYear === year;
  };

  // Returns whether the given year is disabled or not
  $: isDisabled = (year: number) => {
    const yearStart = new Date(year, 0, 1);
    const yearEnd = new Date(year, 12, 1, 0, 0, 0, -1);
    const min = minDate;
    const max = maxDate;

    return (min && yearEnd < min) || (max && yearStart > max);
  };
</script>

<style lang="postcss">
  .yearsContainer {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
  }

  .yearsContainer > button.today {
    color: var(--ubilabs-calendar-tile-now-color);
  }

  .yearsContainer > button.selected {
    background-color: var(--ubilabs-calendar-tile-has-active-background-color);
  }

  .yearsContainer > button.selected:not([disabled]):hover,
  .yearsContainer > button.selected:not([disabled]):focus-visible {
    background-color: var(
      --ubilabs-calendar-tile-has-active-hover-background-color
    );
  }
</style>

<div class="yearsContainer">
  {#each {length: maxYear - minYear + 1} as _, yearIndex (yearIndex)}
    <button
      class:today={isToday(minYear + yearIndex)}
      class:selected={isSelected(minYear + yearIndex)}
      disabled={isDisabled(minYear + yearIndex)}
      on:click|preventDefault={() => {
        if (!isDisabled(minYear + yearIndex)) {
          dispatch('select', minYear + yearIndex);
        }
      }}
      bind:this={yearRefs[minYear + yearIndex]}>
      {minYear + yearIndex}
    </button>
  {/each}
</div>
